import React from 'react';

function Testimonials() {
  const testimonials = [
    {
      name: 'Khawar Ahmad',
      role: 'Business Owner',
      company: 'E-commerce Store',
      text: 'They took time to understand requirements and delivers excellent work. I had lot of small changes along the way based on internal reviews and they always came through with good solutions. Highly recommended!',
      rating: 5
    },
    {
      name: 'Ahmed Ogundimu',
      role: 'CEO',
      company: 'Tech Startup',
      text: 'Job done to specification. They accepted job criticism in good faith and made necessary improvements as required. I am not easily satisfied but I will definitely work again.',
      rating: 5
    },
    {
      name: 'Elvir Salcinovic',
      role: 'Marketing Director',
      company: 'Digital Agency',
      text: 'Great work experience with great communication and on time finishing all details and ready to finish all to be as clients need.',
      rating: 5
    },
    {
      name: 'Sarah Mitchell',
      role: 'Founder',
      company: 'Local Boutique',
      text: 'Our Shopify store is beautiful and converts really well. Sales increased by 40% in the first month. Worth every penny!',
      rating: 5
    }
  ];

  return (
    <section className="testimonials">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <div className="section-label">CLIENT SUCCESS STORIES</div>
          <h2 className="testimonials-title">Trusted by Growing Businesses</h2>
          <p className="testimonials-subtitle">
            Join 200+ satisfied clients who transformed their digital presence
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.name.charAt(0)}</div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role} • {testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials-cta">
          <p className="cta-text">Ready to grow your business online?</p>
          <a href="#contact" className="cta-button">
            Get Your Free Quote Today →
          </a>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
